import { render, staticRenderFns } from "./ModalCadastroHospitaisGarantiaMinimaGlobal.vue?vue&type=template&id=486b8a11"
import script from "./ModalCadastroHospitaisGarantiaMinimaGlobal.vue?vue&type=script&lang=ts"
export * from "./ModalCadastroHospitaisGarantiaMinimaGlobal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports